@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(300_845_674)
internal val Res.string.join_table: StringResource by lazy {
      StringResource("string:join_table", "join_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19008, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17412, 34),
      ))
    }

@delegate:ResourceContentHash(-743_797_238)
internal val Res.string.kick_player_confirm: StringResource by lazy {
      StringResource("string:kick_player_confirm", "kick_player_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19080, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17468, 35),
      ))
    }

@delegate:ResourceContentHash(591_483_165)
internal val Res.string.kick_player_dialog_message: StringResource by lazy {
      StringResource("string:kick_player_dialog_message", "kick_player_dialog_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19120, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17504, 70),
      ))
    }

@delegate:ResourceContentHash(-1_297_588_310)
internal val Res.string.kick_player_dialog_title: StringResource by lazy {
      StringResource("string:kick_player_dialog_title", "kick_player_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19191, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17575, 52),
      ))
    }

@delegate:ResourceContentHash(-1_301_409_148)
internal val Res.string.kill_all: StringResource by lazy {
      StringResource("string:kill_all", "kill_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19252, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17628, 28),
      ))
    }

@delegate:ResourceContentHash(-451_310_436)
internal val Res.string.launch_table: StringResource by lazy {
      StringResource("string:launch_table", "launch_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19285, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17657, 36),
      ))
    }

@delegate:ResourceContentHash(-1_471_478_085)
internal val Res.string.leave_table: StringResource by lazy {
      StringResource("string:leave_table", "leave_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19535, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17879, 35),
      ))
    }

@delegate:ResourceContentHash(-408_203_977)
internal val Res.string.leave_table_confirm_action: StringResource by lazy {
      StringResource("string:leave_table_confirm_action", "leave_table_confirm_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19326, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17694, 42),
      ))
    }

@delegate:ResourceContentHash(996_493_959)
internal val Res.string.leave_table_message: StringResource by lazy {
      StringResource("string:leave_table_message", "leave_table_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19373, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17737, 99),
      ))
    }

@delegate:ResourceContentHash(-1_471_415_107)
internal val Res.string.leave_table_title: StringResource by lazy {
      StringResource("string:leave_table_title", "leave_table_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19485, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17837, 41),
      ))
    }

@delegate:ResourceContentHash(-1_615_822_998)
internal val Res.string.load_more_events: StringResource by lazy {
      StringResource("string:load_more_events", "load_more_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19579, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17915, 48),
      ))
    }

@delegate:ResourceContentHash(-1_551_982_217)
internal val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19640, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17964, 31),
      ))
    }

@delegate:ResourceContentHash(-1_246_921_002)
internal val Res.string.lockpicking_active: StringResource by lazy {
      StringResource("string:lockpicking_active", "lockpicking_active", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19676, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17996, 50),
      ))
    }

@delegate:ResourceContentHash(1_626_367_435)
internal val Res.string.lockpicking_cancel_activity: StringResource by lazy {
      StringResource("string:lockpicking_cancel_activity", "lockpicking_cancel_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19727, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18047, 55),
      ))
    }

@delegate:ResourceContentHash(1_490_337_184)
internal val Res.string.lockpicking_close: StringResource by lazy {
      StringResource("string:lockpicking_close", "lockpicking_close", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19791, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18103, 33),
      ))
    }

@delegate:ResourceContentHash(-174_957_236)
internal val Res.string.lockpicking_launch: StringResource by lazy {
      StringResource("string:lockpicking_launch", "lockpicking_launch", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19886, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18198, 34),
      ))
    }

@delegate:ResourceContentHash(645_279_200)
internal val Res.string.lockpicking_launch_title: StringResource by lazy {
      StringResource("string:lockpicking_launch_title", "lockpicking_launch_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19825, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18137, 60),
      ))
    }

@delegate:ResourceContentHash(903_951_235)
internal val Res.string.lockpicking_lock_count_label: StringResource by lazy {
      StringResource("string:lockpicking_lock_count_label", "lockpicking_lock_count_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19921, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18233, 64),
      ))
    }

@delegate:ResourceContentHash(-1_661_871_210)
internal val Res.string.lockpicking_locks_progress: StringResource by lazy {
      StringResource("string:lockpicking_locks_progress", "lockpicking_locks_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 19990, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18298, 58),
      ))
    }

@delegate:ResourceContentHash(-45_073_192)
internal val Res.string.lockpicking_minimize: StringResource by lazy {
      StringResource("string:lockpicking_minimize", "lockpicking_minimize", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20053, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18357, 40),
      ))
    }

@delegate:ResourceContentHash(1_711_464_188)
internal val Res.string.lockpicking_open: StringResource by lazy {
      StringResource("string:lockpicking_open", "lockpicking_open", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20094, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18398, 48),
      ))
    }

@delegate:ResourceContentHash(-401_306_197)
internal val Res.string.lockpicking_show_lock_count: StringResource by lazy {
      StringResource("string:lockpicking_show_lock_count", "lockpicking_show_lock_count", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20147, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18447, 71),
      ))
    }

@delegate:ResourceContentHash(-1_926_365_019)
internal val Res.string.lockpicking_sound_enabled: StringResource by lazy {
      StringResource("string:lockpicking_sound_enabled", "lockpicking_sound_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20235, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18519, 53),
      ))
    }

@delegate:ResourceContentHash(1_266_323_070)
internal val Res.string.lockpicking_success_message: StringResource by lazy {
      StringResource("string:lockpicking_success_message", "lockpicking_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20293, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18573, 55),
      ))
    }

@delegate:ResourceContentHash(-1_300_144_936)
internal val Res.string.lockpicking_target_player: StringResource by lazy {
      StringResource("string:lockpicking_target_player", "lockpicking_target_player", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20365, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18629, 53),
      ))
    }

@delegate:ResourceContentHash(1_316_952_564)
internal val Res.string.lockpicking_time_limit_enabled: StringResource by lazy {
      StringResource("string:lockpicking_time_limit_enabled", "lockpicking_time_limit_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20419, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18683, 62),
      ))
    }

@delegate:ResourceContentHash(1_802_156_497)
internal val Res.string.lockpicking_time_limit_label: StringResource by lazy {
      StringResource("string:lockpicking_time_limit_label", "lockpicking_time_limit_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20494, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18746, 60),
      ))
    }

@delegate:ResourceContentHash(513_208_820)
internal val Res.string.lockpicking_timeout_message: StringResource by lazy {
      StringResource("string:lockpicking_timeout_message", "lockpicking_timeout_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20559, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18807, 51),
      ))
    }

@delegate:ResourceContentHash(-89_226_463)
internal val Res.string.master_audio_console: StringResource by lazy {
      StringResource("string:master_audio_console", "master_audio_console", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20619, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18859, 56),
      ))
    }

@delegate:ResourceContentHash(860_333_549)
internal val Res.string.message_gm_info_banner: StringResource by lazy {
      StringResource("string:message_gm_info_banner", "message_gm_info_banner", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20680, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18916, 114),
      ))
    }

@delegate:ResourceContentHash(-1_700_984_204)
internal val Res.string.message_gm_visibility_warning: StringResource by lazy {
      StringResource("string:message_gm_visibility_warning", "message_gm_visibility_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20811, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19031, 97),
      ))
    }

@delegate:ResourceContentHash(1_631_355_831)
internal val Res.string.message_new_conversation: StringResource by lazy {
      StringResource("string:message_new_conversation", "message_new_conversation", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20921, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19129, 56),
      ))
    }

@delegate:ResourceContentHash(678_826_772)
internal val Res.string.message_recipients: StringResource by lazy {
      StringResource("string:message_recipients", "message_recipients", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 20982, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19186, 30),
      ))
    }

@delegate:ResourceContentHash(1_078_683_106)
internal val Res.string.message_send_button_desc: StringResource by lazy {
      StringResource("string:message_send_button_desc", "message_send_button_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21017, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19217, 48),
      ))
    }

@delegate:ResourceContentHash(-2_131_316_792)
internal val Res.string.message_to_all: StringResource by lazy {
      StringResource("string:message_to_all", "message_to_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21074, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19266, 38),
      ))
    }

@delegate:ResourceContentHash(155_082_842)
internal val Res.string.messages_empty: StringResource by lazy {
      StringResource("string:messages_empty", "messages_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21121, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19305, 46),
      ))
    }

@delegate:ResourceContentHash(-45_073_192)
internal val Res.string.minimize_announcement: StringResource by lazy {
      StringResource("string:minimize_announcement", "minimize_announcement", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21184, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19352, 41),
      ))
    }

@delegate:ResourceContentHash(-2_131_316_792)
internal val Res.string.module_all_participants: StringResource by lazy {
      StringResource("string:module_all_participants", "module_all_participants", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21226, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19394, 47),
      ))
    }

@delegate:ResourceContentHash(1_881_648_419)
internal val Res.string.module_announcement: StringResource by lazy {
      StringResource("string:module_announcement", "module_announcement", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21371, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19523, 43),
      ))
    }

@delegate:ResourceContentHash(1_140_686_101)
internal val Res.string.module_announcement_desc: StringResource by lazy {
      StringResource("string:module_announcement_desc", "module_announcement_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21282, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19442, 80),
      ))
    }

@delegate:ResourceContentHash(1_626_849_088)
internal val Res.string.module_combat: StringResource by lazy {
      StringResource("string:module_combat", "module_combat", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21522, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19666, 29),
      ))
    }

@delegate:ResourceContentHash(2_019_027_093)
internal val Res.string.module_combat_desc: StringResource by lazy {
      StringResource("string:module_combat_desc", "module_combat_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21411, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19567, 98),
      ))
    }

@delegate:ResourceContentHash(559_803_712)
internal val Res.string.module_digicode: StringResource by lazy {
      StringResource("string:module_digicode", "module_digicode", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21633, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19769, 35),
      ))
    }

@delegate:ResourceContentHash(892_940_499)
internal val Res.string.module_digicode_desc: StringResource by lazy {
      StringResource("string:module_digicode_desc", "module_digicode_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21552, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19696, 72),
      ))
    }

@delegate:ResourceContentHash(1_702_662_853)
internal val Res.string.module_gm_timer: StringResource by lazy {
      StringResource("string:module_gm_timer", "module_gm_timer", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21754, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19886, 35),
      ))
    }

@delegate:ResourceContentHash(-1_903_314_054)
internal val Res.string.module_gm_timer_desc: StringResource by lazy {
      StringResource("string:module_gm_timer_desc", "module_gm_timer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21669, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19805, 80),
      ))
    }

@delegate:ResourceContentHash(489_668_657)
internal val Res.string.module_lockpicking: StringResource by lazy {
      StringResource("string:module_lockpicking", "module_lockpicking", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21886, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20010, 42),
      ))
    }

@delegate:ResourceContentHash(-178_077_428)
internal val Res.string.module_lockpicking_desc: StringResource by lazy {
      StringResource("string:module_lockpicking_desc", "module_lockpicking_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21794, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19922, 87),
      ))
    }

@delegate:ResourceContentHash(1_157_920_214)
internal val Res.string.module_participants: StringResource by lazy {
      StringResource("string:module_participants", "module_participants", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21929, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20053, 43),
      ))
    }

@delegate:ResourceContentHash(1_736_309_183)
internal val Res.string.module_status_active: StringResource by lazy {
      StringResource("string:module_status_active", "module_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 21977, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20097, 44),
      ))
    }

@delegate:ResourceContentHash(-1_797_357_059)
internal val Res.string.module_status_cancelled: StringResource by lazy {
      StringResource("string:module_status_cancelled", "module_status_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22018, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20142, 43),
      ))
    }

@delegate:ResourceContentHash(-826_419_083)
internal val Res.string.module_status_failed: StringResource by lazy {
      StringResource("string:module_status_failed", "module_status_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22062, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20186, 36),
      ))
    }

@delegate:ResourceContentHash(-996_005_580)
internal val Res.string.module_status_success: StringResource by lazy {
      StringResource("string:module_status_success", "module_status_success", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22103, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20223, 41),
      ))
    }

@delegate:ResourceContentHash(-726_608_211)
internal val Res.string.module_status_timeout: StringResource by lazy {
      StringResource("string:module_status_timeout", "module_status_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22145, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20265, 41),
      ))
    }

@delegate:ResourceContentHash(-157_767_191)
internal val Res.string.module_timer: StringResource by lazy {
      StringResource("string:module_timer", "module_timer", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22269, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20377, 28),
      ))
    }

@delegate:ResourceContentHash(-579_469_664)
internal val Res.string.module_timer_desc: StringResource by lazy {
      StringResource("string:module_timer_desc", "module_timer_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22195, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20307, 69),
      ))
    }

@delegate:ResourceContentHash(8_403_761)
internal val Res.string.module_whiteboard: StringResource by lazy {
      StringResource("string:module_whiteboard", "module_whiteboard", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22401, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20485, 41),
      ))
    }

@delegate:ResourceContentHash(275_724_633)
internal val Res.string.module_whiteboard_desc: StringResource by lazy {
      StringResource("string:module_whiteboard_desc", "module_whiteboard_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22302, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20406, 78),
      ))
    }

@delegate:ResourceContentHash(-1_037_055_488)
internal val Res.string.modules: StringResource by lazy {
      StringResource("string:modules", "modules", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22447, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20527, 27),
      ))
    }

@delegate:ResourceContentHash(1_479_483_727)
internal val Res.string.more_options: StringResource by lazy {
      StringResource("string:more_options", "more_options", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22475, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20555, 36),
      ))
    }

@delegate:ResourceContentHash(946_710_158)
internal val Res.string.my_characters: StringResource by lazy {
      StringResource("string:my_characters", "my_characters", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22516, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20592, 41),
      ))
    }

@delegate:ResourceContentHash(187_829_828)
internal val Res.string.my_universes: StringResource by lazy {
      StringResource("string:my_universes", "my_universes", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22558, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20634, 36),
      ))
    }

@delegate:ResourceContentHash(1_138_025_926)
internal val Res.string.next_track: StringResource by lazy {
      StringResource("string:next_track", "next_track", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22595, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20671, 34),
      ))
    }

@delegate:ResourceContentHash(-506_872_712)
internal val Res.string.no_character_yet: StringResource by lazy {
      StringResource("string:no_character_yet", "no_character_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22634, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20706, 60),
      ))
    }

@delegate:ResourceContentHash(-1_235_835_610)
internal val Res.string.no_characters_yet: StringResource by lazy {
      StringResource("string:no_characters_yet", "no_characters_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22695, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20767, 89),
      ))
    }

@delegate:ResourceContentHash(-1_631_451_104)
internal val Res.string.no_file_selected: StringResource by lazy {
      StringResource("string:no_file_selected", "no_file_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22809, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20857, 48),
      ))
    }

@delegate:ResourceContentHash(423_261_717)
internal val Res.string.no_players_yet: StringResource by lazy {
      StringResource("string:no_players_yet", "no_players_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22870, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20906, 62),
      ))
    }

@delegate:ResourceContentHash(2_041_074_440)
internal val Res.string.no_premades_yet: StringResource by lazy {
      StringResource("string:no_premades_yet", "no_premades_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 22925, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20969, 103),
      ))
    }

@delegate:ResourceContentHash(-6_645_824)
internal val Res.string.notes: StringResource by lazy {
      StringResource("string:notes", "notes", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23202, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21194, 21),
      ))
    }

@delegate:ResourceContentHash(1_145_575_268)
internal val Res.string.notes_empty_gm: StringResource by lazy {
      StringResource("string:notes_empty_gm", "notes_empty_gm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23069, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21073, 62),
      ))
    }

@delegate:ResourceContentHash(649_941_840)
internal val Res.string.notes_placeholder: StringResource by lazy {
      StringResource("string:notes_placeholder", "notes_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23140, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21136, 57),
      ))
    }

@delegate:ResourceContentHash(-1_387_046_829)
internal val Res.string.notification_item_received: StringResource by lazy {
      StringResource("string:notification_item_received", "notification_item_received", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23224, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21216, 58),
      ))
    }

@delegate:ResourceContentHash(-530_841_932)
internal val Res.string.notification_player_joined: StringResource by lazy {
      StringResource("string:notification_player_joined", "notification_player_joined", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23291, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21275, 58),
      ))
    }

@delegate:ResourceContentHash(525_893_285)
internal val Res.string.now_playing: StringResource by lazy {
      StringResource("string:now_playing", "now_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23350, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21334, 35),
      ))
    }

@delegate:ResourceContentHash(1_937_568_650)
internal val Res.string.onboarding_community_description: StringResource by lazy {
      StringResource("string:onboarding_community_description", "onboarding_community_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23382, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21370, 124),
      ))
    }

@delegate:ResourceContentHash(-756_420_944)
internal val Res.string.onboarding_community_title: StringResource by lazy {
      StringResource("string:onboarding_community_title", "onboarding_community_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23523, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21495, 58),
      ))
    }

@delegate:ResourceContentHash(-588_917_539)
internal val Res.string.onboarding_gm_description: StringResource by lazy {
      StringResource("string:onboarding_gm_description", "onboarding_gm_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23590, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21554, 161),
      ))
    }

@delegate:ResourceContentHash(361_355_435)
internal val Res.string.onboarding_gm_title: StringResource by lazy {
      StringResource("string:onboarding_gm_title", "onboarding_gm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23800, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21716, 51),
      ))
    }

@delegate:ResourceContentHash(-13_739_936)
internal val Res.string.onboarding_link_bluesky: StringResource by lazy {
      StringResource("string:onboarding_link_bluesky", "onboarding_link_bluesky", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23844, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21768, 43),
      ))
    }

@delegate:ResourceContentHash(-182_701_994)
internal val Res.string.onboarding_link_discord: StringResource by lazy {
      StringResource("string:onboarding_link_discord", "onboarding_link_discord", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23888, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21812, 55),
      ))
    }

@delegate:ResourceContentHash(877_897_088)
internal val Res.string.onboarding_link_instagram: StringResource by lazy {
      StringResource("string:onboarding_link_instagram", "onboarding_link_instagram", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23948, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21868, 45),
      ))
    }

@delegate:ResourceContentHash(-448_800_899)
internal val Res.string.onboarding_link_site: StringResource by lazy {
      StringResource("string:onboarding_link_site", "onboarding_link_site", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23994, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21914, 40),
      ))
    }

@delegate:ResourceContentHash(1_767_913_951)
internal val Res.string.onboarding_link_youtube: StringResource by lazy {
      StringResource("string:onboarding_link_youtube", "onboarding_link_youtube", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24035, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21955, 51),
      ))
    }

@delegate:ResourceContentHash(1_942_775_311)
internal val Res.string.onboarding_player_description: StringResource by lazy {
      StringResource("string:onboarding_player_description", "onboarding_player_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24087, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22007, 145),
      ))
    }

@delegate:ResourceContentHash(512_984_369)
internal val Res.string.onboarding_player_title: StringResource by lazy {
      StringResource("string:onboarding_player_title", "onboarding_player_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24317, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22153, 47),
      ))
    }

@delegate:ResourceContentHash(-111_740_205)
internal val Res.string.onboarding_subtitle: StringResource by lazy {
      StringResource("string:onboarding_subtitle", "onboarding_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24373, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22201, 75),
      ))
    }

@delegate:ResourceContentHash(43_366_143)
internal val Res.string.onboarding_table_description: StringResource by lazy {
      StringResource("string:onboarding_table_description", "onboarding_table_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24461, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22277, 128),
      ))
    }

@delegate:ResourceContentHash(532_688_502)
internal val Res.string.onboarding_table_title: StringResource by lazy {
      StringResource("string:onboarding_table_title", "onboarding_table_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24606, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22406, 66),
      ))
    }

@delegate:ResourceContentHash(-1_421_507_995)
internal val Res.string.onboarding_universe_description: StringResource by lazy {
      StringResource("string:onboarding_universe_description", "onboarding_universe_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24673, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22473, 139),
      ))
    }

@delegate:ResourceContentHash(1_135_644_873)
internal val Res.string.onboarding_universe_title: StringResource by lazy {
      StringResource("string:onboarding_universe_title", "onboarding_universe_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24813, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22613, 73),
      ))
    }

@delegate:ResourceContentHash(-1_862_200_607)
internal val Res.string.otp_code_hint: StringResource by lazy {
      StringResource("string:otp_code_hint", "otp_code_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24891, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22687, 37),
      ))
    }

@delegate:ResourceContentHash(-315_655_207)
internal val Res.string.otp_resend_button: StringResource by lazy {
      StringResource("string:otp_resend_button", "otp_resend_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24937, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22725, 41),
      ))
    }

@delegate:ResourceContentHash(1_926_359_281)
internal val Res.string.otp_sent_to: StringResource by lazy {
      StringResource("string:otp_sent_to", "otp_sent_to", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24987, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22767, 59),
      ))
    }

@delegate:ResourceContentHash(-610_591_467)
internal val Res.string.otp_title: StringResource by lazy {
      StringResource("string:otp_title", "otp_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25071, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22827, 41),
      ))
    }

@delegate:ResourceContentHash(247_579_113)
internal val Res.string.otp_verify_button: StringResource by lazy {
      StringResource("string:otp_verify_button", "otp_verify_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25117, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22869, 33),
      ))
    }

@delegate:ResourceContentHash(-1_866_957_182)
internal val Res.string.player_unknown: StringResource by lazy {
      StringResource("string:player_unknown", "player_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25155, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22903, 42),
      ))
    }

@delegate:ResourceContentHash(442_297_636)
internal val Res.string.players: StringResource by lazy {
      StringResource("string:players", "players", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25198, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22946, 27),
      ))
    }

@delegate:ResourceContentHash(-2_117_875_103)
internal val Res.string.premade_add_item: StringResource by lazy {
      StringResource("string:premade_add_item", "premade_add_item", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25226, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22974, 44),
      ))
    }

@delegate:ResourceContentHash(-1_933_718_715)
internal val Res.string.premade_characters: StringResource by lazy {
      StringResource("string:premade_characters", "premade_characters", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25271, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23019, 54),
      ))
    }

@delegate:ResourceContentHash(-1_065_208_846)
internal val Res.string.premade_choose: StringResource by lazy {
      StringResource("string:premade_choose", "premade_choose", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25314, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23074, 30),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("join_table", Res.string.join_table)
  map.put("kick_player_confirm", Res.string.kick_player_confirm)
  map.put("kick_player_dialog_message", Res.string.kick_player_dialog_message)
  map.put("kick_player_dialog_title", Res.string.kick_player_dialog_title)
  map.put("kill_all", Res.string.kill_all)
  map.put("launch_table", Res.string.launch_table)
  map.put("leave_table", Res.string.leave_table)
  map.put("leave_table_confirm_action", Res.string.leave_table_confirm_action)
  map.put("leave_table_message", Res.string.leave_table_message)
  map.put("leave_table_title", Res.string.leave_table_title)
  map.put("load_more_events", Res.string.load_more_events)
  map.put("loading", Res.string.loading)
  map.put("lockpicking_active", Res.string.lockpicking_active)
  map.put("lockpicking_cancel_activity", Res.string.lockpicking_cancel_activity)
  map.put("lockpicking_close", Res.string.lockpicking_close)
  map.put("lockpicking_launch", Res.string.lockpicking_launch)
  map.put("lockpicking_launch_title", Res.string.lockpicking_launch_title)
  map.put("lockpicking_lock_count_label", Res.string.lockpicking_lock_count_label)
  map.put("lockpicking_locks_progress", Res.string.lockpicking_locks_progress)
  map.put("lockpicking_minimize", Res.string.lockpicking_minimize)
  map.put("lockpicking_open", Res.string.lockpicking_open)
  map.put("lockpicking_show_lock_count", Res.string.lockpicking_show_lock_count)
  map.put("lockpicking_sound_enabled", Res.string.lockpicking_sound_enabled)
  map.put("lockpicking_success_message", Res.string.lockpicking_success_message)
  map.put("lockpicking_target_player", Res.string.lockpicking_target_player)
  map.put("lockpicking_time_limit_enabled", Res.string.lockpicking_time_limit_enabled)
  map.put("lockpicking_time_limit_label", Res.string.lockpicking_time_limit_label)
  map.put("lockpicking_timeout_message", Res.string.lockpicking_timeout_message)
  map.put("master_audio_console", Res.string.master_audio_console)
  map.put("message_gm_info_banner", Res.string.message_gm_info_banner)
  map.put("message_gm_visibility_warning", Res.string.message_gm_visibility_warning)
  map.put("message_new_conversation", Res.string.message_new_conversation)
  map.put("message_recipients", Res.string.message_recipients)
  map.put("message_send_button_desc", Res.string.message_send_button_desc)
  map.put("message_to_all", Res.string.message_to_all)
  map.put("messages_empty", Res.string.messages_empty)
  map.put("minimize_announcement", Res.string.minimize_announcement)
  map.put("module_all_participants", Res.string.module_all_participants)
  map.put("module_announcement", Res.string.module_announcement)
  map.put("module_announcement_desc", Res.string.module_announcement_desc)
  map.put("module_combat", Res.string.module_combat)
  map.put("module_combat_desc", Res.string.module_combat_desc)
  map.put("module_digicode", Res.string.module_digicode)
  map.put("module_digicode_desc", Res.string.module_digicode_desc)
  map.put("module_gm_timer", Res.string.module_gm_timer)
  map.put("module_gm_timer_desc", Res.string.module_gm_timer_desc)
  map.put("module_lockpicking", Res.string.module_lockpicking)
  map.put("module_lockpicking_desc", Res.string.module_lockpicking_desc)
  map.put("module_participants", Res.string.module_participants)
  map.put("module_status_active", Res.string.module_status_active)
  map.put("module_status_cancelled", Res.string.module_status_cancelled)
  map.put("module_status_failed", Res.string.module_status_failed)
  map.put("module_status_success", Res.string.module_status_success)
  map.put("module_status_timeout", Res.string.module_status_timeout)
  map.put("module_timer", Res.string.module_timer)
  map.put("module_timer_desc", Res.string.module_timer_desc)
  map.put("module_whiteboard", Res.string.module_whiteboard)
  map.put("module_whiteboard_desc", Res.string.module_whiteboard_desc)
  map.put("modules", Res.string.modules)
  map.put("more_options", Res.string.more_options)
  map.put("my_characters", Res.string.my_characters)
  map.put("my_universes", Res.string.my_universes)
  map.put("next_track", Res.string.next_track)
  map.put("no_character_yet", Res.string.no_character_yet)
  map.put("no_characters_yet", Res.string.no_characters_yet)
  map.put("no_file_selected", Res.string.no_file_selected)
  map.put("no_players_yet", Res.string.no_players_yet)
  map.put("no_premades_yet", Res.string.no_premades_yet)
  map.put("notes", Res.string.notes)
  map.put("notes_empty_gm", Res.string.notes_empty_gm)
  map.put("notes_placeholder", Res.string.notes_placeholder)
  map.put("notification_item_received", Res.string.notification_item_received)
  map.put("notification_player_joined", Res.string.notification_player_joined)
  map.put("now_playing", Res.string.now_playing)
  map.put("onboarding_community_description", Res.string.onboarding_community_description)
  map.put("onboarding_community_title", Res.string.onboarding_community_title)
  map.put("onboarding_gm_description", Res.string.onboarding_gm_description)
  map.put("onboarding_gm_title", Res.string.onboarding_gm_title)
  map.put("onboarding_link_bluesky", Res.string.onboarding_link_bluesky)
  map.put("onboarding_link_discord", Res.string.onboarding_link_discord)
  map.put("onboarding_link_instagram", Res.string.onboarding_link_instagram)
  map.put("onboarding_link_site", Res.string.onboarding_link_site)
  map.put("onboarding_link_youtube", Res.string.onboarding_link_youtube)
  map.put("onboarding_player_description", Res.string.onboarding_player_description)
  map.put("onboarding_player_title", Res.string.onboarding_player_title)
  map.put("onboarding_subtitle", Res.string.onboarding_subtitle)
  map.put("onboarding_table_description", Res.string.onboarding_table_description)
  map.put("onboarding_table_title", Res.string.onboarding_table_title)
  map.put("onboarding_universe_description", Res.string.onboarding_universe_description)
  map.put("onboarding_universe_title", Res.string.onboarding_universe_title)
  map.put("otp_code_hint", Res.string.otp_code_hint)
  map.put("otp_resend_button", Res.string.otp_resend_button)
  map.put("otp_sent_to", Res.string.otp_sent_to)
  map.put("otp_title", Res.string.otp_title)
  map.put("otp_verify_button", Res.string.otp_verify_button)
  map.put("player_unknown", Res.string.player_unknown)
  map.put("players", Res.string.players)
  map.put("premade_add_item", Res.string.premade_add_item)
  map.put("premade_characters", Res.string.premade_characters)
  map.put("premade_choose", Res.string.premade_choose)
}
